import { FC, PropsWithChildren, useMemo } from 'react';

import DefaultClient from '@/api/DefaultClient';
import ServiceStackContext from '@/contexts/api/ServiceStackClientContext';
import { useTheme } from '@mui/material';


interface IServiceStackClientProviderProps {
    baseUrl?: string;
    basePath?: string;
}

const ServiceStackClientProvider: FC<PropsWithChildren<IServiceStackClientProviderProps>> = ({ 
    children,
    baseUrl,
    basePath
}) => {
    const theme = useTheme();

    const client = useMemo(() => {
        return DefaultClient(baseUrl, basePath, theme.palette.mode)
    }, [baseUrl, basePath, theme.palette.mode])

    return (
        <ServiceStackContext.Provider value={client}>
            {children}
        </ServiceStackContext.Provider>
    )
}

export default ServiceStackClientProvider